export default {
  features: {
    applicationItemsFillMarking: {
      button: 'Markirovkani qo‘shish',
      modal: {
        title: "Quyidagi mahsulotlar uchun belgini to'ldiring",
        alert: "Kod kamida 38 belgidan iborat bo'lishi kerak (birinchi 18 ta belgi raqamlar bo'lishi kerak)",
        successAlert: 'Belgi muvaffaqiyati saqlandi',
        close: 'Yopish',
      },
      form: {
        marking: {
          placeholder: 'Belgi',
        },
      },
    },
  },
};
